import { Injectable } from '@angular/core';
import HomeStats from '../../../types/stats/HomeStats';
import SampleCumulativeStats from '../../../types/stats/SampleCumulativeStats';
import SampleProcessLogStats from '../../../types/stats/SampleProcessLogStats';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root'
})
export class StatsService {

    private RESOURCE: string = 'stats';

    constructor(private baseService: BaseService) {
    }

    /**
     * Fetches the home stats from the backend.
     *
     * @return The home stats.
     */
    public async getHomeStats(): Promise<HomeStats> {
        return await this.baseService.get<HomeStats>(this.RESOURCE + '/home');
    }

    /**
     * Fetches the process log stats from the backend.
     *
     * @return The process log stats.
     */
    public async getProcessLogStats(): Promise<SampleProcessLogStats> {
        return await this.baseService.get<SampleProcessLogStats>(this.RESOURCE + '/logs-per-day');
    }

    /**
     * Fetches the cumulative sample stats from the backend.
     *
     * @return The cumulative sample stats.
     */
    public async getCumulativeSampleStats(): Promise<SampleCumulativeStats> {
        return await this.baseService.get<SampleCumulativeStats>(this.RESOURCE + '/cumulative-samples');
    }
}
